"use client";
import React, { useEffect } from "react";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger
} from "@/components/ui/alert-dialog";
import { Mixpanel } from "@/elements/Mixpanel";

export default function ConfirmModal({ children, onConfirm, disabled, header, description }) {
    return (
        <AlertDialog>
            <AlertDialogTrigger disabled={disabled} asChild>
                {children}
            </AlertDialogTrigger>
            <AlertDialogContent className="w-[456px] rounded-2xl">
                <AlertDialogHeader>
                    <AlertDialogTitle className="text-center text-2xl font-bold text-black">{header}</AlertDialogTitle>
                </AlertDialogHeader>
                {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
                <AlertDialogFooter>
                    <AlertDialogCancel className="text-base font-bold w-full bg-[#EB4E2C] text-white hover:text-white border-none hover:bg-[#EB4E2C]/90 disabled:bg-[#9D9D9D]">
                        No
                    </AlertDialogCancel>
                    <AlertDialogAction
                        className="text-base font-bold w-full bg-[#33A34D] text-white hover:text-white border-none hover:bg-[#33A34D]/90 disabled:bg-[#9D9D9D] ml-4"
                        onClick={onConfirm}
                        disabled={disabled}
                    >
                        Yes
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
